/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, Container, Link, Typography } from "@mui/material";
import FacebookIcon from "assets/Footer/FacebookIcon";
import InstagramIcon from "assets/Footer/InstagramIcon";
import LinkedinIcon from "assets/Footer/Linkedin";
import XIcon from "assets/Footer/X";
import Logo from "components/Logo/Logo";
import React from "react";
import { useNavigate } from "react-router-dom";

const socialIcon = [
  { id: 1, Icon: XIcon, link: "https://x.com/Xane_AI" },
  { id: 2, Icon: FacebookIcon, link: "https://www.facebook.com/xanebot/" },
  { id: 3, Icon: InstagramIcon, link: "https://www.instagram.com/xaneai" },
  { id: 4, Icon: LinkedinIcon, link: "https://www.linkedin.com/company/xaneai" },
];
const footerLinks = [
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms & Conditions", href: "/terms" },
  { label: "Cookies Policy", href: "/cookies" },
  { label: "Disclaimer", href: "/disclaimer" },
];
const Details = [
  {
    id: 1,
    heading: "About Xane AI",
    name: ["About Us", "How It Works", "Contact Us"],
  },
  // {
  //   id: 2,
  //   heading: "Company",
  //   name: ["Privacy Policy", "Terms & Conditions", "Cookies Policy", ""],
  // },
  {
    id: 3,
    heading: "More",
    name: ["", "FAQs", ""],
  },
];

export default function Footer() {
  const navigate = useNavigate();
  const handleAbout = () => {
    navigate("/about");
  };
  const handleWorks = () => {
    navigate("/works");
  };
  const handleBlogs = () => {
    navigate("/blogs");
  };
  const handleContact = () => {
    navigate("/contact");
  };
  const handlePrivacy = () => {
    navigate("/privacy");
  };
  const handleTerm = () => {
    navigate("/terms");
  };
  const handleCookies = () => {
    navigate("/cookies");
  };
  const handleDisclaimer = () => {
    navigate("/disclaimer");
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "24px",
        alignSelf: "stretch",
        padding: { xs: "20px", sm: "10px 20px", md: "10px 20px" },
        background: "#020A0D",
        width: "100%",
      }}
    >
      <Container>
        <Box
          sx={{
            display: "flex",
            alignItems: { xs: "center", sm: "flex-start", md: "flex-start" },
            alignContent: { xs: "none", sm: "flex-start", md: "flex-start" },
            justifyContent: { xs: "none", sm: "center", md: "center" },
            gap: { xs: "12px", sm: "24px", md: "24px" },
            alignSelf: { xs: "stretch", sm: "stretch", md: "stretch" },
            flexWrap: { xs: "nowrap", sm: "wrap", md: "wrap" },
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              alignItems: { xs: "center", sm: "center", md: "center" },
              flexDirection: { xs: "column", sm: "row", md: "row" },
              justifyContent: { xs: "center", sm: "none", md: "start" },

              gap: { xs: "24px", sm: "84px", md: "119px" },

              padding: { xs: "0px", sm: "0px 96px", md: "0px 96px" },
              alignSelf: { xs: "stretch", sm: "stretch", md: "stretch" },
              flex: { xs: "1 0 0", sm: " 0 0 0", md: "1 0 0" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "24px",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  width: { xs: "144px", sm: "180px", md: "180px" },
                  height: { xs: "80px", sm: "80px", md: "80px" },
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: { xs: "5.29px", sm: "6.613px", md: "6.613px" },
                }}
              >
                <Logo />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: { xs: "12px", sm: "27px", md: "27px" },
                  alignSelf: "stretch",
                }}
              >
                {socialIcon.map(({ id, Icon, link }) => (
                  <Link
                    key={id}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "inline-block" }}
                  >
                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        transition: "0.3s ease-in-out",
                        "&:hover": {
                          color: "#FFFFFF",
                          filter: "drop-shadow(0 0 10px white)",
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      <Icon color="#333333" />
                    </Box>
                  </Link>
                ))}
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start", md: "flex-start" },
                alignItems: { xs: "center", sm: "flex-start", md: "flex-start" },
                flexDirection: { xs: "column", sm: "row", md: "row" },
                gap: { xs: "32px", sm: "24px", md: "84px" },
                // flex: { xs: "0 0 0", sm: "1 0 0", md: "1 0 0" },
              }}
            >
              {Details.map((detail) => (
                <Box
                  key={detail.id}
                  sx={{
                    display: "flex",
                    padding: { xs: "0px", sm: "12px 0px 16px 0px", md: "12px 0px 16px 0px" },
                    flexDirection: "column",
                    alignItems: { xs: "center", sm: "flex-start", md: "flex-start" },
                    gap: { xs: "16px", sm: "12px", md: "8px" },
                    alignSelf: "stretch",
                    minWidth: "145px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#8B8E90",
                      fontFamily: "Inter",
                      fontSize: { xs: "19px", sm: "23px", md: "23px" },
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "140%",
                    }}
                  >
                    {detail.heading}
                  </Typography>
                  {detail.name.map((item, indx) => (
                    <Typography
                      // eslint-disable-next-line react/no-array-index-key
                      key={`detail-name-text-${item}-${indx}`}
                      onClick={() => {
                        if (item === "About Us") handleAbout();
                        else if (item === "How It Works") handleWorks();
                        else if (item === "Contact Us") handleContact();
                        else if (item === "Blogs") handleBlogs();
                        else if (item === "FAQs") handleWorks();
                        else if (item === "Privacy Policy") handlePrivacy();
                        else if (item === "Terms & Conditions") handleTerm();
                        else if (item === "Cookies Policy") handleCookies();
                        else if (item === "Disclaimer") handleDisclaimer();
                      }}
                      sx={{
                        color: "#8B8E90",
                        fontFamily: "Inter",
                        fontSize: { xs: "16px", sm: "19px", md: "19px" },
                        fontStyle: "normal",
                        fontWeight: 400,
                        lineHeight: "140%",
                        textDecoration: "none",
                        cursor: "pointer",
                      }}
                    >
                      {item}
                    </Typography>
                  ))}
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: { xs: "center", sm: "center", md: "center" },
            alignItems: { xs: "center", sm: "center", md: "center" },
            gap: { xs: "10px", sm: "10px", md: "10px" },
            padding: { xs: "8px 0px", sm: "8px 0px", md: "16px 16px" },
          }}
        >
          <Typography
            sx={{
              color: "#8B8E90",
              fontFamily: "Inter",
              fontSize: { xs: "11px", sm: "16px", md: "16px" },
              fontWeight: { xs: 400, sm: 500, md: 500 },
              lineHeight: { xs: 1.4, sm: 1.4, md: 1.4 },
              textAlign: { xs: "center", sm: "center", md: "center" },
              flex: "1 0 0",
            }}
          >
            © {new Date().getFullYear()} Profformance Technologies Private Limited. All Rights
            Reserved.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {footerLinks.map((item, index) => (
              <Box key={item.label} sx={{ display: "flex", alignItems: "center" }}>
                <Link
                  href={item.href}
                  underline="hover"
                  rel="noopener noreferrer"
                  sx={{
                    color: "#8B8E90",
                    fontFamily: "Inter",
                    fontSize: { xs: "11px", sm: "16px", md: "16px" },
                    fontWeight: { xs: 400, sm: 500, md: 500 },
                    lineHeight: 1.4,
                  }}
                >
                  {item.label}{" "}
                  {index !== footerLinks.length - 1 && (
                    <Box
                      component="span"
                      sx={{
                        color: "#8B8E90",
                        fontWeight: 700,
                      }}
                    >
                      |
                    </Box>
                  )}
                </Link>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
